import { Box, LinearProgress, Typography } from "@mui/material";
import React from "react";

export const ProgressFallback = ({ message }: { message?: string }) => {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        minHeight: "100%",
        padding: 3,
        gap: 2,
      }}
    >
      <Box width={400}>
        <LinearProgress />
      </Box>
      {message ? (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      ) : null}
    </Box>
  );
};
